d<template>
  <div class="times_cont">
    <div class="big-leader-container">
      <div class="head">
        <div class="head_title">
          <!-- <img src="../assets/Starting/img-leader/logo.png" /> -->
          {{ title }}
        </div>
      </div>
      <div class="body">
        <div class="body-left">
          <div class="leader-info">
            <div class="header-img">
              <img :src="imgUrl + this.leaderBasic[0].head" alt />
              <!-- <img src="http://45.40.228.47:8080/picture/111.jpeg" alt=""> -->
              <span class="leader_name">{{ this.leaderBasic[0].name }}</span>
            </div>
            <div class="leader-intro">
              <p class="text">{{ this.leaderBasic[0].introduction }}</p>
            </div>
          </div>
          <div class="leader-photo">
            <div class="title">图集</div>
            <div class="photos">
              <el-carousel :autoplay="false" arrow="never" ref="carousel" height="340px">
                <el-carousel-item v-for="(item, index) in num" :key="index" name="index">
                  <div v-if="item == '1'" class="photo animated">
                    <!-- <img class="onst_photo"  src="http://45.40.228.47:8080/picture/111.jpeg" alt=""> -->
                    <img
                      class="item_img"
                      v-for="(items, index) in imgList.slice(0, 6)"
                      :key="index"
                      :src="items"
                    />
                  </div>
                  <div v-if="item == '2'" class="photo animated">
                    <!-- <img class="onst_photo"  src="http://45.40.228.47:8080/picture/111.jpeg" alt=""> -->
                    <img
                      class="item_img"
                      v-for="(items, index) in imgList.slice(6, 12)"
                      :key="index"
                      name="index"
                      :src="items"
                    />
                  </div>
                  <div v-if="item == '3'" class="photo animated">
                    <!-- <img class="onst_photo"  src="http://45.40.228.47:8080/picture/111.jpeg" alt=""> -->
                    <img
                      class="item_img"
                      v-for="(items, index) in imgList.slice(12, 18)"
                      :key="index"
                      name="index"
                      :src="items"
                    />
                  </div>
                  <div v-if="item == '4'" class="photo animated">
                    <!-- <img class="onst_photo"  src="http://45.40.228.47:8080/picture/111.jpeg" alt=""> -->
                    <img
                      class="item_img"
                      v-for="(items, index) in imgList.slice(18, 24)"
                      :key="index"
                      name="index"
                      :src="items"
                    />
                  </div>
                  <div v-if="item == '5'" class="photo animated">
                    <!-- <img class="onst_photo"  src="http://45.40.228.47:8080/picture/111.jpeg" alt=""> -->
                    <img
                      class="item_img"
                      v-for="(items, index) in imgList.slice(24, 30)"
                      :key="index"
                      name="index"
                      :src="items"
                    />
                  </div>
                </el-carousel-item>
              </el-carousel>
              <div class="left_button" @click="leftChange('prev')">
                <img class="left_img" src="@/assets/Uram/leader/left.png" alt />
              </div>
              <div class="right_button" @click="rightChange('next')">
                <img class="right_img" src="@/assets/Uram/leader/right.png" alt />
              </div>
            </div>
          </div>
        </div>
        <div class="body-right">
          <div class="title">时间脉络</div>
          <div class="yutou"></div>
          <!-- <img class="yutou" src="../assets/Starting/img-leader/yutou.png" /> -->
          <div class="vertical-line"></div>
          <span class="iconfont icon-xiala1"></span>
          <div class="experience-list" v-for="(item, index) in leaderLive.slice(0, 8)" :key="index">
            <div class="experience-list">
              <div class="line"></div>
              <span class="iconfont icon-AppIcon-copy"></span>
              <div class="experience">
                <div class="ltime">
                  <i class="icon-yuan"></i>
                  {{ item.newsTime }}
                </div>
                <div class="live" @click="goMon(item)">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
        <div class="title_time">
          <div class="dia_title">{{ this.date.title }}</div>
          <img class="body_img" @click="goindr(date.url)" src="@/assets/lian.png" alt />
        </div>
        <div class="live">时间:{{ this.date.newsTime }}</div>
        <div class="body_tiele">
          {{ this.date.live }}
          <div class="time_img">
            <div class="wx_img" v-for="(item, index) in imgs" :key="index">
              <img v-if="item.imgUrl != ''" class="img_wx" :src="item.imgUrl" alt />
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer"></span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { getLeader, getLeaderById, upload } from "../api/re";
export default {
  data() {
    return {
      title: "时政要闻",
      num: "",
      left: 0,
      right: 6,
      god: 1,
      dialogImageUrl: "",
      file: [],
      head: "",
      imgs: [],
      atlas: [],
      userId: [],
      userId2: "",
      userId: "",
      leaderBasic: [
        {
          tenantId: 2,
          introduction:
            "中铁京雄（北京）高速公路发展有限公司副总经理、总经济师",
          name: "宋震",
          head: "/fileserver/lsg-cloud/20221118102451-8852835545031102684.jpg",
          atlas:
            "/fileserver/lsg-cloud/20221118102127-5985295059185610406.jpg,/fileserver/lsg-cloud/20221118102210-8957935294994858834.jpg,/fileserver/lsg-cloud/20221118102129-7748612050127114119.jpg,/fileserver/lsg-cloud/20221118102134-7876246955820284677.jpg",
          tag: 0,
          createTime: null,
          updateTime: 1668740384168,
          id: 220
        }
      ],
      leaderLive: [],
      date: {
        live: "",
        newsTime: ""
      },
      arr: [],
      imgList: [],
      dialogVisible: false,
      dataes: "测试数据"
    };
  },
  computed: {
    imgUrl() {
      return location.origin;
    }
  },
  watch: {
    dataes: {
      handler(newName, oldName) {
        this.load();
        this.dataes = "测试数据";
        window.sessionStorage.setItem("dataes", JSON.stringify(this.dataes));
      }
    }
  },
  created() {
    setInterval(() => {
      this.dataes = JSON.parse(window.sessionStorage.getItem("dataes"));
    }, 50);

    this.load();
  },
  mounted() {
    this.websket();
  },
  methods: {
    websket() {
      // 检查浏览器是否支持SSE
      var supid = JSON.parse(window.sessionStorage.getItem("supid"));
      if ("EventSource" in window) {
        var source = new EventSource(
          // "http://192.168.31.206:50001/sse/connect/leader"+supid
          "https://www.lsgcloud.com/sse/connect/leader" + supid
        );
        source.onmessage = function(e) {
          //监听信息的传输

          if (e.data == "领导人大屏数据变动") {
            window.sessionStorage.setItem("dataes", JSON.stringify(e.data));
          }

          origin = e.origin;
        };

        source.onopen = function(e) {
          //当连接正式建立时触发
          console.log("连接打开.");
        };

        source.onerror = function(e) {
          //当连接发生error时触发
          if (e.readyState == EventSource.CLOSED) {
            console.log("连接关闭");
          } else {
            console.log("onerror:" + e.readyState);
          }
        };
      } else {
        console.log("没有sse");
      }
    },
    goMon(item) {
      this.dialogVisible = true;
      this.date = item;
      var coom = [];
      //图片处理
      coom.push((item.img || "").split(","));
      coom[0].forEach(item => {
        this.imgs.push({
          imgUrl: item
        });
      });
    },
    goindr(url) {
      if (url !== null) {
        window.open(url);
      }
    },
    handleClose(done) {
      this.imgs = [];
      this.dialogVisible = false;
    },
    // 轮播左
    leftChange(prev) {
      this.$refs["carousel"][prev]();
    },
    // 轮播右
    rightChange(next) {
      this.$refs["carousel"][next]();
    },
    handleRemove(file, fileList) {},
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    load() {
      //领导人userId
      var supid = JSON.parse(window.sessionStorage.getItem("supid"));
      getLeader({
        tenantId: 24
      }).then(res => {
        this.userId = res.data.data[0].id;
        this.lond();
        let userId = [];
        res.data.data.map(item => {
          userId.push(item.userId);
        });
        sessionStorage.setItem("key", userId[0]);
        this.leaderBasic = res.data.data;
        let str = this.leaderBasic[0].atlas;
        if (str) {
          this.imgList = (str || "").split(",");
        }
        var datafasle = [];
        var datatrue = [];
        datafasle = this.imgList.filter(item => {
          return item.indexOf("/fileserver/lsg-cloud") == -1; //false
        });
        datatrue = this.imgList.filter(item => {
          return item.indexOf("/fileserver/lsg-cloud") != -1; //true
        });
        console.log(datafasle, "完整路径");
        console.log(datatrue, "不完整路径");
        var listto = [];
        datatrue.forEach(item => {
          listto.push(this.imgUrl + item);
        });
        console.log(listto, "我要的的路径");

        this.imgList = listto.concat(datafasle);
        console.log(this.imgList, "完成了");
        console.log(this.imgList.length, "完成了///////////");
        if (this.imgList.length <= 6) {
          this.num = 1;
        } else if (this.imgList.length > 6 && this.imgList.length <= 12) {
          this.num = 2;
        } else if (this.imgList.length > 12 && this.imgList.length <= 18) {
          this.num = 3;
        } else if (this.imgList.length > 18 && this.imgList.length <= 24) {
          this.num = 4;
        } else if (this.imgList.length > 24 && this.imgList.length <= 30) {
          this.num = 5;
        } else {
          this.num = 5;
        }
      });
    },
    lond() {
      //领导人信息,图集,时间脉络图
      getLeaderById({
        leaderId: 228
      }).then(res => {
        this.leaderLive = res.data.data;
        // this.monNum();
      });
    }
    // monNum() {
    //   console.log(
    //     this.imgList.length,
    //     "this.imgListthis.imgListthis.imgListthis.imgList"
    //   );
    //   if (this.imgList.length <= 6) {
    //     this.num = 1;
    //   } else if (this.imgList.length > 6 && this.imgList.length <= 12) {
    //     this.num = 2;
    //   } else if (this.imgList.length > 12 && this.imgList.length <= 18) {
    //     this.num = 3;
    //   } else if (this.imgList.length > 18 && this.imgList.length <= 24) {
    //     this.num = 4;
    //   } else if (this.imgList.length > 24 && this.imgList.length <= 30) {
    //     this.num = 5;
    //   } else {
    //     this.num = 5;
    //   }
    // },
  }
};
</script>

<style lang="scss">
.el-carousel__container {
  height: 35vh !important;
}
.time_img {
  width: 100%;
  height: 5vh;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.wx_img {
  padding: 10px;
  .img_wx {
    width: 170px;
    height: 140px;
  }
}
.body_tiele {
  font-size: 22px;
  line-height: 28px;
  color: #fff;

  color: #ffffff;
  text-align: center;
  position: relative;
  width: 95%;
  height: 63vh;
  margin: 0 auto;
  overflow-y: scroll;
}
.dia_title {
  width: 100%;
  text-align: center;
  height: 50px;

  overflow: hidden;
  margin: 0 auto;
  font-size: 30px;
  font-family: PingFang;
  font-weight: bold;
  color: #ffffff;
  line-height: 50px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.title_time {
  width: 80%;
  height: 50px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
}
.body_img {
  width: 35px;
  height: 35px;
  position: relative;
  top: 5px;
  cursor: pointer;
}
.live {
  font-size: calc(100vw * 16 / 1920);
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 50px;
  color: #ffffff;
  float: right;
  position: relative;
  left: -40px;
  color: #60d6dd;
}
.onst_photo {
  width: 250px;
  height: 150px;
}
.item_img {
  margin-left: 5px;
  margin-top: 16px;
  // width: 232px;
  // height: 122px;
  width: 30%;
  height: 45%;
}
.left_button {
  position: relative;
  top: -32vh;
  color: #fff;
  width: 25px;
  z-index: 100;
  left: -25px;
  height: 32vh;
  background-image: url("../assets/Uram/leader/heng.png");
  background-size: 100% 100%;
  cursor: pointer;
  .left_img {
    position: absolute;
    top: 40%;
    left: 20%;
  }
}
.right_button {
  position: relative;
  top: -64vh;
  color: #fff;
  width: 25px;
  z-index: 100;
  left: 98.5%;
  height: 32vh;
  background-image: url("../assets/Uram/leader/heng.png");
  background-size: 100% 100%;
  cursor: pointer;
  .right_img {
    position: absolute;
    top: 40%;
    left: 30%;
  }
}
.times_cont {
  width: 100%;
  height: 100%;
  background: url("../assets/lobot.png") no-repeat;
  background-size: 100% 100%;
  padding-left: 4%;
  padding-right: 4%;
}
.big-leader-container {
  background-image: url("../assets/Starting/img-leader/wnmq.png");
  background-size: 100% 100%;
  position: relative;
  height: 100%;
  .head {
    width: 100%;
    height: 9.5vh;
    display: flex;
    color: #fff;
    .head_title {
      font-weight: bold;
      font-size: 2vw;
      line-height: 12vh;
      width: 19%;
      margin-left: 2.3%;
      overflow: hidden;
      text-align: center;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #fff;
      img {
        vertical-align: middle;
        width: 13%;
        height: 5.2vh;
        margin-right: 3.2%;
      }
    }
    .head_logo {
      width: 8.67%;
      height: 4.44vh;
      position: absolute;
      top: 4vh;
      right: 4%;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .body {
    height: calc(100% - 37px - 3.9vh - 1%);
    padding-top: 2.2vh;
    display: inline-flex;
    width: 100%;
    .body-left {
      background-image: url("../assets/Starting/img-leader/left_box.png");
      background-size: 100% 100%;
      height: calc(100% - 2.2vh - 2.7vh - 2.3vh);
      margin-left: 3.4%;
      padding-top: 2.3vh;
      display: inline-block;
      width: 42.5%;
      padding: 10px;
      .leader-info {
        background-color: rgba(0, 37, 93, 0.2);
        width: 96%;
        position: relative;
        left: -7%;
        margin: 2% 8%;
        height: 33.3vh;
        display: inline-flex;
        padding-top: 6%;
        padding-left: 4%;
        /*flex-direction: column;*/
        .header-img {
          width: 47%;
          height: calc(28.5vh - 17px);
          background-color: #007bc1;
          padding: 0px 2px;
          padding-top: 17px;
          img {
            width: 100%;
            height: 66%;
            position: relative;
            top: 4%;
          }
          .leader_name {
            color: #fff;
            font-size: 18px;
            text-align: center;
            display: inline-block;
            width: 100%;
            position: relative;
            top: 9%;
          }
        }
        .leader-intro {
          text-indent: 2rem;
          color: #fff;
          font-size: calc(100vw * 16 / 1920);
          width: 100%;
          line-height: 1.5;
          height: calc(28.5vh - 41px);

          margin: 17px 30px;
          padding-bottom: 10px;
          // /* 旧版弹性盒 */
          // display: -webkit-box;
          // /* 弹性盒子元素垂直排列 */
          // -webkit-box-orient: vertical;
          // /* 控制要显示的行数 */
          // -webkit-line-clamp: 5;
          overflow: hidden;
          overflow-y: scroll;
          // border: 1px solid red;
        }
      }
      .leader-photo {
        margin: 0px 5%;
        width: calc(100% - 60px);
        height: calc(100% - 36.4vh - 2.3vh);
        .title {
          font-size: 20px;
          font-weight: bold;
          color: #fff;
          // margin: 27px 0 20px 0;
        }
        .photos {
          .photo {
            display: flex;
            width: 100%;
            justify-content: flex-start;
            flex-wrap: wrap;
            padding: 0 10px;
            height: 100%;
            margin-left: 1vw;
            // border: 1px solid red;
            // img {
            //   width: calc((100% - 30px) / 3);
            //   height: 150px;
            //   margin-left: 15px;
            //   // margin-bottom: 16px;
            //   margin-top: 10px;
            // }
            img:first-child,
            img:nth-child(4) {
              margin-left: 0;
            }
            img:nth-child(4),
            img:nth-child(5),
            img:nth-child(6) {
              margin-bottom: 0;
            }
          }
        }
        .el-carousel__item h3 {
          color: #475669;
          font-size: 14px;
          opacity: 0.75;
          line-height: 150px;
          margin: 0;
        }

        // .el-carousel__item:nth-child(2n) {
        //   background-color: #99a9bf;
        // }

        // .el-carousel__item:nth-child(2n + 1) {
        //   background-color: #d3dce6;
        // }
      }
    }
    .body-right {
      display: inline-block;
      width: calc(54.1% - 50px - 5.5%);
      margin-left: 50px;
      height: 100%;
      position: relative;
      .title {
        font-size: 20px;
        font-weight: bold;
        color: #fff;
      }
      .yutou {
        position: absolute;
        right: 19.8vw;
        top: -4vh;
        width: 3vw;
        height: 7vh;
        z-index: 10;
      }
      .vertical-line {
        width: 0px;
        border-left: 2px dashed #023353;
        position: absolute;
        right: calc(47.3% + 25px);
        top: 1vh;
        height: 79vh;
        z-index: 9;
      }
      .icon-xiala1 {
        position: absolute;
        color: #004976;
        right: calc(47.3% + 17px);
        top: 80vh;
        z-index: 10;
      }
      .experience-list {
        position: absolute;
        z-index: 10;
        .line {
          width: 23vw;
          border-top: 1px solid #b9478c;
        }
        .icon-AppIcon-copy {
          color: #da529e;
          position: absolute;
          top: -7px;
          right: 0px;
        }
        .experience {
          position: absolute;
          width: 100%;
          height: 12vh;
          cursor: pointer;
          background-color: rgba(1, 101, 143, 0.15);
          .ltime {
            color: #fefeff;
            font-size: 14px;
            height: 30px;
            display: inline-flex;
            align-items: center;
            .icon-yuan {
              display: inline-block;
              width: 6px;
              height: 6px;
              border-radius: 50%;
              margin-left: 11px;
              margin-right: 9px;
            }
          }
          .live {
            color: #27cffc;
            font-size: calc(100vw * 16 / 1920);
            padding-left: 27%;
            padding-right: 3%;
            height: 51.2%;
            position: relative;
            top: -1vh;
            overflow: hidden;
            line-height: 1.3;
            width: 100%;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
      }
      .experience-list:nth-child(2n + 1) {
        right: -5%;
        .icon-AppIcon-copy {
          left: -14px;
        }
        .experience {
          right: 0;
        }
      }
      .experience-list:nth-child(2n) {
        right: calc(47.3% + 30px);
        .icon-AppIcon-copy {
          left: 22.8vw;
        }
        .experience {
          left: 0;
        }
      }
      .experience-list:nth-child(5) {
        top: 4.4vh;
        .line {
          border-top: 1px solid #fe5a5b;
        }
        .icon-AppIcon-copy {
          color: #fe5a5b;
        }
        .experience {
          // right: 0;
          .ltime {
            .icon-yuan {
              background-color: #fe5a5b;
            }
          }
        }
      }
      .experience-list:nth-child(6) {
        top: 13.6vh;
        .line {
          border-top: 1px solid #fe5cb1;
        }
        .icon-AppIcon-copy {
          color: #fe5cb1;
        }
        .experience {
          .ltime {
            .icon-yuan {
              background-color: #fe5cb1;
            }
          }
        }
      }
      .experience-list:nth-child(7) {
        top: 22.8vh;
        .line {
          border-top: 1px solid #fde500;
        }
        .icon-AppIcon-copy {
          color: #fde500;
        }
        .experience {
          .ltime {
            .icon-yuan {
              background-color: #fde500;
            }
          }
        }
      }
      .experience-list:nth-child(8) {
        top: 32vh;
        .line {
          border-top: 1px solid #6fe320;
        }
        .icon-AppIcon-copy {
          color: #6fe320;
        }
        .experience {
          .ltime {
            .icon-yuan {
              background-color: #6fe320;
            }
          }
        }
      }
      .experience-list:nth-child(9) {
        top: 41.2vh;
        .line {
          border-top: 1px solid #4fcbff;
        }
        .icon-AppIcon-copy {
          color: #4fcbff;
        }
        .experience {
          .ltime {
            .icon-yuan {
              background-color: #4fcbff;
            }
          }
        }
      }
      .experience-list:nth-child(10) {
        top: 50.4vh;
        .line {
          border-top: 1px solid #4b7af0;
        }
        .icon-AppIcon-copy {
          color: #4b7af0;
        }
        .experience {
          .ltime {
            .icon-yuan {
              background-color: #4b7af0;
            }
          }
        }
      }
      .experience-list:nth-child(11) {
        top: 59.6vh;
        .line {
          border-top: 1px solid #b450fe;
        }
        .icon-AppIcon-copy {
          color: #b450fe;
        }
        .experience {
          .ltime {
            .icon-yuan {
              background-color: #b450fe;
            }
          }
        }
      }
      .experience-list:nth-child(12) {
        top: 68.8vh;
        .line {
          border-top: 1px solid #d8509a;
        }
        .icon-AppIcon-copy {
          color: #d8509a;
        }
        .experience {
          .ltime {
            .icon-yuan {
              background-color: #d8509a;
            }
          }
        }
      }
    }
  }
}
</style>
